interface AvatarProps {
  name?: string;
  size?: number;
  className?: string;
  ring?: boolean;
}

const PALETTE: Array<[string, string]> = [
  ["#1F5A45", "#D9E6DF"],
  ["#B57425", "#F2E2C4"],
  ["#A23D2C", "#F1D9D2"],
  ["#2F5E8A", "#D6E2EF"],
  ["#6B3556", "#E9DCE3"],
  ["#3D3A33", "#E2DBC9"],
];

function colorFor(name = "?"): [string, string] {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function Avatar({ name = "?", size = 28, className = "", ring }: AvatarProps) {
  const [fg, bg] = colorFor(name);
  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        background: bg,
        color: fg,
        fontSize: size * 0.4,
        boxShadow: ring ? `0 0 0 2px rgb(var(--app-surface)), 0 0 0 3px ${fg}` : undefined,
      }}
    >
      {initials}
    </span>
  );
}

interface AvatarStackProps {
  names: string[];
  size?: number;
  max?: number;
}

export function AvatarStack({ names = [], size = 24, max = 4 }: AvatarStackProps) {
  const shown = names.slice(0, max);
  const overflow = names.length - shown.length;
  return (
    <div className="inline-flex items-center">
      {shown.map((n, i) => (
        <span key={`${n}-${i}`} style={{ marginLeft: i === 0 ? 0 : -8 }}>
          <Avatar name={n} size={size} className="border-2 border-surface" />
        </span>
      ))}
      {overflow > 0 && (
        <span
          className="inline-flex items-center justify-center rounded-full bg-bg-2 text-text-2 font-semibold border-2 border-surface"
          style={{ marginLeft: -8, width: size, height: size, fontSize: size * 0.36 }}
        >
          +{overflow}
        </span>
      )}
    </div>
  );
}
